/* This file is auto-generated, manual edits in this file will be overwritten! */

export const i18nKeys = {
  a11y: {
    alert: 'a11y.alert',
    ariaLabel: {
      menu: 'a11y.ariaLabel.menu',
    },
    attention: 'a11y.attention',
    breadcrumb: {
      toggleArrow: 'a11y.breadcrumb.toggleArrow',
    },
    information: 'a11y.information',
    input: 'a11y.input',
    logo: 'a11y.logo',
    selectOption: 'a11y.selectOption',
    tableHeader: 'a11y.tableHeader',
    toolbar: 'a11y.toolbar',
    willExpire: 'a11y.willExpire',
  },
  errors: {
    form: {
      bicFormat: 'errors.form.bicFormat',
      checked: 'errors.form.checked',
      different: 'errors.form.different',
      differentPassword: 'errors.form.differentPassword',
      email: 'errors.form.email',
      equal: 'errors.form.equal',
      ibanFormat: 'errors.form.ibanFormat',
      invalid: 'errors.form.invalid',
      maxLength: 'errors.form.maxLength',
      maxValue: 'errors.form.maxValue',
      minLength: 'errors.form.minLength',
      minValue: 'errors.form.minValue',
      newPassword: 'errors.form.newPassword',
      newPasswordConfirm: 'errors.form.newPasswordConfirm',
      noEmail: 'errors.form.noEmail',
      noPaste: 'errors.form.noPaste',
      password: 'errors.form.password',
      pattern: 'errors.form.pattern',
      phone: 'errors.form.phone',
      required: 'errors.form.required',
      voucherFormat: 'errors.form.voucherFormat',
      website: 'errors.form.website',
    },
    notFoundScreen: {
      cta: 'errors.notFoundScreen.cta',
      subTitle: 'errors.notFoundScreen.subTitle',
      title: 'errors.notFoundScreen.title',
    },
    server: {
      ACTION_UNAVAILABLE_IN_REGION:
        'errors.server.ACTION_UNAVAILABLE_IN_REGION',
      BUSINESS_SERVICE_ERROR: 'errors.server.BUSINESS_SERVICE_ERROR',
      CLIENT_NOT_AUTHENTICATED: 'errors.server.CLIENT_NOT_AUTHENTICATED',
      CONTACT_SUPPORT: 'errors.server.CONTACT_SUPPORT',
      CUSTOMER_ALREADY_HAS_EXTENDED_QUOTA:
        'errors.server.CUSTOMER_ALREADY_HAS_EXTENDED_QUOTA',
      DEFAULT: 'errors.server.DEFAULT',
      ENTITY_NOT_FOUND: 'errors.server.ENTITY_NOT_FOUND',
      EXTERNAL_SERVICE_ERROR: 'errors.server.EXTERNAL_SERVICE_ERROR',
      FORBIDDEN: 'errors.server.FORBIDDEN',
      FORBIDDEN_WRONG_REGION: 'errors.server.FORBIDDEN_WRONG_REGION',
      INTERNAL_SERVER_ERROR: 'errors.server.INTERNAL_SERVER_ERROR',
      INVALID_FILE_FORMAT: 'errors.server.INVALID_FILE_FORMAT',
      INVALID_REQUEST_SYNTAX: 'errors.server.INVALID_REQUEST_SYNTAX',
      KLARNA_ORDER_FAILED: 'errors.server.KLARNA_ORDER_FAILED',
      KLARNA_SESSION_FAILED: 'errors.server.KLARNA_SESSION_FAILED',
      NISS_ALREADY_HAS_EXTENDED_QUOTA_REQUEST:
        'errors.server.NISS_ALREADY_HAS_EXTENDED_QUOTA_REQUEST',
      NOT_ADULT_PROSPECT: 'errors.server.NOT_ADULT_PROSPECT',
      NO_VALID_CONTRACT: 'errors.server.NO_VALID_CONTRACT',
      QUOTA_EXCEEDED: 'errors.server.QUOTA_EXCEEDED',
      VALIDATION_EXCEPTION: 'errors.server.VALIDATION_EXCEPTION',
      VOUCHER_ORDER_FAILED: 'errors.server.VOUCHER_ORDER_FAILED',
      business: {
        FACEVALUE_BLOCKED_EXCHANGE:
          'errors.server.business.FACEVALUE_BLOCKED_EXCHANGE',
      },
      form: {
        CONTACT_SUPPORT: 'errors.server.form.CONTACT_SUPPORT',
        DATA_LIMIT_EXCEEDED: 'errors.server.form.DATA_LIMIT_EXCEEDED',
        DATE_IN_FUTURE: 'errors.server.form.DATE_IN_FUTURE',
        DEFAULT: 'errors.server.form.DEFAULT',
        INVALID: 'errors.server.form.INVALID',
        INVALID_FORMAT: 'errors.server.form.INVALID_FORMAT',
        MINIMUMAGENOTREACHED: 'errors.server.form.MINIMUMAGENOTREACHED',
        MINIMUM_AGE_NOT_REACHED: 'errors.server.form.MINIMUM_AGE_NOT_REACHED',
        MISSING_VALUE: 'errors.server.form.MISSING_VALUE',
        NISS_ALREADY_USED: 'errors.server.form.NISS_ALREADY_USED',
        NISS_MISMATCH: 'errors.server.form.NISS_MISMATCH',
        OUT_OF_ENUM: 'errors.server.form.OUT_OF_ENUM',
        POSTAL_CODE_IN_WRONG_REGION:
          'errors.server.form.POSTAL_CODE_IN_WRONG_REGION',
        START_DATE_GREATER_THAN_END_DATE:
          'errors.server.form.START_DATE_GREATER_THAN_END_DATE',
        UNKNOWN_VALUE: 'errors.server.form.UNKNOWN_VALUE',
        VALUE_ALREADY_EXISTS: 'errors.server.form.VALUE_ALREADY_EXISTS',
        VALUE_TOO_LONG: 'errors.server.form.VALUE_TOO_LONG',
        VALUE_TOO_SHORT: 'errors.server.form.VALUE_TOO_SHORT',
        nissAlreadyUsed: 'errors.server.form.nissAlreadyUsed',
        wrongRegion: 'errors.server.form.wrongRegion',
      },
      maintenance: {
        introText: 'errors.server.maintenance.introText',
        refreshButton: 'errors.server.maintenance.refreshButton',
        title: 'errors.server.maintenance.title',
      },
    },
    serviceUnavailableScreen: {
      cta: 'errors.serviceUnavailableScreen.cta',
      subTitle: 'errors.serviceUnavailableScreen.subTitle',
      title: 'errors.serviceUnavailableScreen.title',
    },
  },
  general: {
    activeTabLabel: 'general.activeTabLabel',
    and: 'general.and',
    appTitle: 'general.appTitle',
    attention: 'general.attention',
    autoCompletedataLoading: 'general.autoCompletedataLoading',
    breadcrumbLabel: 'general.breadcrumbLabel',
    close: 'general.close',
    contractType: {
      MATERNITY: 'general.contractType.MATERNITY',
      STANDARD: 'general.contractType.STANDARD',
    },
    cta: {
      cancel: 'general.cta.cancel',
      delete: 'general.cta.delete',
      details: 'general.cta.details',
      download: 'general.cta.download',
      edit: 'general.cta.edit',
      exchange: 'general.cta.exchange',
      ok: 'general.cta.ok',
      order: 'general.cta.order',
      previous: 'general.cta.previous',
      refund: 'general.cta.refund',
      retry: 'general.cta.retry',
      save: 'general.cta.save',
      validate: 'general.cta.validate',
    },
    datePicker: {
      addonText: 'general.datePicker.addonText',
      addonTooltip: 'general.datePicker.addonTooltip',
    },
    daysCount: 'general.daysCount',
    errors: {
      form: {
        autocomplete: {
          minLength: 'general.errors.form.autocomplete.minLength',
        },
        invalidStreet: 'general.errors.form.invalidStreet',
      },
    },
    first: 'general.first',
    form: {
      errorMessage: 'general.form.errorMessage',
      validationErrorMessage: 'general.form.validationErrorMessage',
    },
    hidePassword: 'general.hidePassword',
    keyword: 'general.keyword',
    label: {
      amount: 'general.label.amount',
      bankAccount: 'general.label.bankAccount',
      beneficiaryIban: 'general.label.beneficiaryIban',
      bic: 'general.label.bic',
      city: 'general.label.city',
      contractType: 'general.label.contractType',
      dateFormat: 'general.label.dateFormat',
      emailAddress: 'general.label.emailAddress',
      firstName: 'general.label.firstName',
      iban: 'general.label.iban',
      itIsMyDeliveryAddress: 'general.label.itIsMyDeliveryAddress',
      mobilePhoneNumber: 'general.label.mobilePhoneNumber',
      name: 'general.label.name',
      niss: 'general.label.niss',
      number: 'general.label.number',
      paymentDate: 'general.label.paymentDate',
      paymentMethod: 'general.label.paymentMethod',
      paymentType: {
        bankTransfer: 'general.label.paymentType.bankTransfer',
        klarna: 'general.label.paymentType.klarna',
      },
      phoneNumber: 'general.label.phoneNumber',
      postcode: 'general.label.postcode',
      product: 'general.label.product',
      quantity: 'general.label.quantity',
      street: 'general.label.street',
      title: 'general.label.title',
      total: 'general.label.total',
      voucherType: 'general.label.voucherType',
    },
    language: {
      DE: 'general.language.DE',
      FR: 'general.language.FR',
      NL: 'general.language.NL',
    },
    last: 'general.last',
    mainAddress: 'general.mainAddress',
    mobile: {
      update: {
        body: {
          mandatory: 'general.mobile.update.body.mandatory',
          optional: 'general.mobile.update.body.optional',
        },
        cta: {
          continue: 'general.mobile.update.cta.continue',
          update: 'general.mobile.update.cta.update',
        },
        title: 'general.mobile.update.title',
      },
    },
    mobilePermissions: {
      externalStorage: {
        message: 'general.mobilePermissions.externalStorage.message',
        title: 'general.mobilePermissions.externalStorage.title',
      },
    },
    monthCount: 'general.monthCount',
    navigation: 'general.navigation',
    next: 'general.next',
    noResults: 'general.noResults',
    notYetDefined: 'general.notYetDefined',
    optionPlaceholder: 'general.optionPlaceholder',
    or: 'general.or',
    page: 'general.page',
    pageLoading: 'general.pageLoading',
    pager: {
      of: 'general.pager.of',
    },
    paymentMethod: {
      BANCONTACT: 'general.paymentMethod.BANCONTACT',
      BANK_TRANSFER: 'general.paymentMethod.BANK_TRANSFER',
      INSTANT_PAYMENT: 'general.paymentMethod.INSTANT_PAYMENT',
      MASTERCARD: 'general.paymentMethod.MASTERCARD',
      ONLINE_PAYMENT: 'general.paymentMethod.ONLINE_PAYMENT',
      VISA: 'general.paymentMethod.VISA',
    },
    personalDetails: 'general.personalDetails',
    previous: 'general.previous',
    search: 'general.search',
    showPassword: 'general.showPassword',
    statusType: {
      DEFAULT: 'general.statusType.DEFAULT',
      PAID: 'general.statusType.PAID',
      PENDING: 'general.statusType.PENDING',
      PROCESSING: 'general.statusType.PROCESSING',
      RECEIVED: 'general.statusType.RECEIVED',
      SENT: 'general.statusType.SENT',
    },
    supportType: {
      ELECTRONIC: 'general.supportType.ELECTRONIC',
      PAPER: 'general.supportType.PAPER',
    },
    title: {
      MR: 'general.title.MR',
      MRS: 'general.title.MRS',
    },
    upload: {
      error: 'general.upload.error',
      label: 'general.upload.label',
      labelDrag: 'general.upload.labelDrag',
      remove: 'general.upload.remove',
      removeAll: 'general.upload.removeAll',
    },
    voucher: 'general.voucher',
    vouchersCount: 'general.vouchersCount',
  },
};
